import { ErrorBag, Errors } from "@inertiajs/core";
import { Component } from "vue";
import { Config } from 'ziggy-js';
import { TenantThemeEnum, BlockResource, MenuResource, CartResource, ProductResource } from "@/Types/generated.d";

export interface Auth {
    user: User | null;
}
export interface TreeNode {
    id: number;
    name: string;
    label: string;
    checked: boolean;
    indeterminate: boolean;
    visible: boolean;
    opened: boolean;
    is_default: boolean;
    children: TreeNode[];
}
export interface PaginationLinks {
    url: string | null;
    label: string;
    active: boolean;
}
export interface PaginationMeta {
    current_page: number;
    first_page_url: string;
    from: number | null;
    last_page: number;
    last_page_url: string;
    next_page_url: string | null;
    path: string;
    per_page: number;
    prev_page_url: string | null;
    to: number | null;
    total: number;
}
export interface PaginatedCollection<T extends object> {
    data: T[];
    links: PaginationLinks[];
    meta: PaginationMeta;
}
export interface SupportedLocale {
    name: string;
    native: string;
    regional: string;
    script: string;
    flag: string | undefined;
    link: string | undefined;
}
export interface BreadcrumbItem {
    url: string;
    title: string;
}
export interface Tenant {
    id: number;
    name: string;
    logo: string;
}
export interface User {
    id: number;
    firstname: string;
    lastname: string;
    email: string;
}
export interface ModalState {
    component: Component | null;
    props?: Record<string, any>;
    callbacks?: ModalEvent[];
}
export interface LocaleState {
    currentLocale: string;
    supportedLocales: Record<string, SupportedLocale>;
    supportedLocalesCount: number;
}
export interface CartState {
    loading: boolean;
    cart: CartResource | null;
    cartLinesCount: number;
    crossSellingProducts: ProductResource[];
}
export interface ModalEvent {
    event: string;
    action: (args?: any) => void;
}
export enum AlertTypeEnum {
    ERROR = "error",
    WARNING = "warning",
    SUCCESS = "success",
    INFO = "info",
}
export type PageProps<T extends Record<string, unknown> = Record<string, unknown>> = T & {
    app_name: string;
    app_contact_email: string;
    app_support_email: string;
    auth: Auth;
    blocks: BlockResource[];
    menus: MenuResource[];
    cart_count: number;
    marketplaces_count: number;
    csrf_token: string | null;
    query: string | null;
    breadcrumbs: BreadcrumbItem[];
    supported_locales: Record<string, SupportedLocale>;
    current_locale: string;
    default_locale: string;
    default_country: string;
    default_currency: string;
    errors: Errors & ErrorBag;
    flash_messages: Record<AlertTypeEnum, string | null>;
    logo: string | undefined;
    is_impersonating: boolean;
    google_recaptcha_public_key: string | null;
    google_tag_manager: string | null;
    google_map_api_key: string | null;
    previous_url: string | null;
    facebook: string | null;
    youtube: string | null;
    instagram: string | null;
    theme: TenantThemeEnum;
    tenants: Tenant[];
    ziggy: Config & { location: string };
};
